import React from "react";
import { withRouter } from "react-router-dom";
import withFirebase from "../hoc/withFirebase";
import withUser from "../hoc/withUser";
import UpdateInfo from "../components/UpdateInfo";

class UpdateInfoContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      currentUser: []
    };
  }
  updateUserInfo = (
    name,
    email,
    imageURL,
    phoneNumber,
    panNo,
    organisationId
  ) => {
    this.props.db
      .collection("users")
      .doc(this.props.user.uid)
      .update({
        name: name,
        email: email,
        imageURL: imageURL,
        phoneNumber: phoneNumber,
        panNumber: panNo,
        organisationId: organisationId
      });
  };
  updateOrganisation = (currentOrganisationId, currentOrganisationName) => {
    this.props.db
      .collection("organisations")
      .doc(currentOrganisationId)
      .update({
        organisationName: currentOrganisationName
      });
  };
  addOrganisation = organisation => {
    this.props.db
      .collection("organisations")
      .add(organisation)
      .then(docRef => {
        this.props.db
          .collection("users")
          .doc(organisation.createdBy)
          .update({
            organisationId: docRef.id
          });
      });
  };
  render() {
    const { user, currentUser, organisations } = this.props;
    return (
      <UpdateInfo
        user={user}
        updateUserInfo={this.updateUserInfo}
        currentUser={currentUser}
        organisations={organisations}
        updateOrganisation={this.updateOrganisation}
        addOrganisation={this.addOrganisation}
      />
    );
  }
}
export default withRouter(withUser(withFirebase(UpdateInfoContainer)));
